import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useCurrentViewOptions } from 'modules/shift_management/hooks/useCurrentViewOptions'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { ShiftManagementFeatureFlags } from 'modules/shift_management/lib/consts/ShiftManagementFeatureFlags'
import { EmployeeOptions } from 'modules/shift_management/store/internal/models/ViewOptions'

import Toggler from '../Toggler'

interface Props {
  onChange: (option: keyof EmployeeOptions) => void
}

const EmployeeOptionsContent = ({ onChange }: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const hasPlanningBalanceEnabled = hasFeatureFlag(
    ShiftManagementFeatureFlags.DEV_TIME_PLANNING_BALANCES_IN_SHIFTS
  )
  const hasBankOfHoursEnabled = hasFeatureFlag(
    ShiftManagementFeatureFlags.DEV_TIME_PLANNING_BANK_OF_HOURS
  )
  const { viewOptions } = useCurrentViewOptions()
  const { employee } = viewOptions
  const {
    showJobPosition,
    showContractHours,
    showPlannedHours,
    showAvatar,
    showRole,
    showPlanningBalance,
    showBankOfHours,
  } = employee

  return (
    <>
      <Text color="grey700" size="50" weight="bold" caps>
        {i18n.t('shift_management.view_options.titles.employee')}
      </Text>
      <Box gap="s8">
        {hasPlanningBalanceEnabled && (
          <Toggler option="showAvatar" value={showAvatar} onChange={() => onChange('showAvatar')} />
        )}
        {hasPlanningBalanceEnabled ? (
          <>
            <Toggler option="showRole" value={showRole} onChange={() => onChange('showRole')} />
            <Toggler
              option="showPlanningBalance"
              value={showPlanningBalance}
              onChange={() => onChange('showPlanningBalance')}
            />
            {hasBankOfHoursEnabled && (
              <Toggler
                option="showBankOfHours"
                value={showBankOfHours}
                onChange={() => onChange('showBankOfHours')}
              />
            )}
          </>
        ) : (
          // TODO: All these and related logic to be removed when the feature flag is removed
          <>
            <Toggler
              option="showJobPosition"
              value={showJobPosition}
              onChange={() => onChange('showJobPosition')}
            />
            <Toggler
              option="showContractHours"
              value={showContractHours}
              onChange={() => onChange('showContractHours')}
            />
            <Toggler
              option="showPlannedHours"
              value={showPlannedHours}
              onChange={() => onChange('showPlannedHours')}
            />
          </>
        )}
      </Box>
    </>
  )
}

export default observer(EmployeeOptionsContent)
